import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { SvgIconProps } from '@mui/material/SvgIcon';
import React from 'react';

const ExpandIcon = (props: SvgIconProps) => <ExpandMoreIcon {...props} />;
export default ExpandIcon;
